export const clientInfo = {
    brand: 'Vectorsport-stag',
    // mDomain: 'http://192.168.1.108:3000', // physical phone
    mDomain: 'https://i938hsapi110.vectorsport.com/k8wsg/',
    apk: 'https://i938hsapp.vectorsport.com/apk/vectorsport-stag.apk',
    ios: 'https://i.diawi.com/BvC231',
    ver: 'ver:1.250506-stag',
    intent: 'vectorsport-stag://'
};